import { REACT_APP_AUTH_API_URL } from './constants';

export const AUTH_TOKEN_KEY = 'authToken';

export const setAuthToken = token =>
  localStorage.setItem(AUTH_TOKEN_KEY, token);

export const getAuthToken = () => localStorage.getItem(AUTH_TOKEN_KEY);

export const delAuthToken = () => localStorage.removeItem(AUTH_TOKEN_KEY);

export async function loginAuthService(identifier, password) {
  const response = await fetch(REACT_APP_AUTH_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ identifier, password }),
  });

  if (!response.ok) {
    throw new Error(`Auth service error: ${response.status}`);
  }

  const data = await response.json();
  const accessToken = data.accessToken || data.access_token;

  if (!accessToken) {
    throw new Error('accessToken not found in auth service response');
  }

  return accessToken;
}
